<template>
  <header class="navbar">
    <div class="navbar-container">
      <!-- Logo -->
      <div class="logo">
        <router-link to="/">
          <span class="logo-mark">
            <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
          </span>
          <span class="logo-text">TraSok</span>
        </router-link>
      </div>

      <!-- 导航菜单 -->
      <nav class="nav-menu">
        <ul class="nav-list">
          <li
              v-for="item in navItems"
              :key="item.path"
              class="nav-item"
          >
            <router-link
                :to="item.path"
                class="nav-link"
                active-class="active"
            >
              {{ item.meta.title }}
            </router-link>
          </li>
        </ul>
      </nav>

      <!-- 右侧功能区 -->
      <div class="nav-actions">
        <button class="icon-btn" aria-label="搜索">
          <i class="icon-search"></i>
        </button>
        <button class="icon-btn" aria-label="用户">
          <i class="icon-user"></i>
        </button>
      </div>
    </div>
    <!-- 底部流光扫描线 -->
    <span class="scan-line" />
  </header>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Navbar',
  computed: {
    // 安全兜底:路由未加载时返回空数组
    navItems() {
      return this.$route?.matched?.[0]?.children || [];
    },
  },
};
</script>

<style scoped>
/* ========== 外层:深色玻璃 + 流光描边 ========== */
.navbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  background:
      radial-gradient(120% 140% at 0% 0%, rgba(79, 141, 255, 0.55) 0%, transparent 55%),
      radial-gradient(120% 140% at 100% 100%, rgba(79, 209, 255, 0.35) 0%, transparent 55%),
      linear-gradient(135deg, #0b1538 0%, #162663 50%, #2a4ab8 100%);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  border-bottom: 1px solid rgba(120, 160, 255, 0.18);
  box-shadow:
      0 8px 32px -12px rgba(0, 0, 0, 0.6),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
  overflow: hidden;
}

.navbar::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(
      90deg,
      transparent,
      rgba(120, 170, 255, 0.9),
      rgba(180, 120, 255, 0.9),
      transparent
  );
  opacity: 0.8;
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: relative;
  z-index: 1;
}

/* ========== Logo ========== */
.logo a {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.logo-mark {
  position: relative;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #4f8dff, #9d7bff);
  box-shadow:
      0 0 14px rgba(100, 140, 255, 0.55),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* 悬停时外圈脉冲光环 */
.logo-mark::after {
  content: '';
  position: absolute;
  inset: -4px;
  border-radius: 14px;
  border: 1px solid rgba(120, 170, 255, 0.5);
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.logo a:hover .logo-mark::after {
  opacity: 1;
  transform: scale(1);
  animation: pulse 1.6s ease-out infinite;
}
@keyframes pulse {
  0%   { box-shadow: 0 0 0 0 rgba(120, 170, 255, 0.55); }
  100% { box-shadow: 0 0 0 10px rgba(120, 170, 255, 0); }
}

.logo a:hover .logo-mark {
  transform: rotate(-8deg) scale(1.05);
  box-shadow:
      0 0 22px rgba(120, 160, 255, 0.8),
      inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.logo-img {
  height: 24px;
  width: 24px;
  object-fit: contain;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  background: linear-gradient(90deg, #ffffff, #a9c2ff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* ========== 导航 ========== */
.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 6px;
}

.nav-item {
  position: relative;
}

.nav-link {
  position: relative;
  display: block;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 500;
  color: rgba(220, 228, 255, 0.72);
  text-decoration: none;
  border-radius: 8px;
  overflow: hidden;
  isolation: isolate;
  transition: color 0.25s ease, background 0.25s ease,
  box-shadow 0.25s ease, border-color 0.25s ease;
  border: 1px solid transparent;
}

/* 悬停:淡蓝底 + 霓虹描边 + 扫描光带 */
.nav-link:hover {
  color: #fff;
  background: rgba(79, 141, 255, 0.14);
  border-color: rgba(120, 170, 255, 0.55);
  box-shadow:
      0 0 12px rgba(79, 141, 255, 0.45),
      inset 0 0 10px rgba(79, 141, 255, 0.15);
}

/* 扫描光带:悬停时从左到右扫过 */
.nav-link .glow {
  position: absolute;
  top: 0; bottom: 0;
  left: -120%;
  width: 60%;
  background: linear-gradient(
      90deg,
      transparent,
      rgba(120, 190, 255, 0.55),
      transparent
  );
  transform: skewX(-20deg);
  pointer-events: none;
  transition: none;
}
.nav-link:hover .glow {
  animation: sweep 0.9s ease-out;
}
@keyframes sweep {
  0%   { left: -120%; }
  100% { left: 140%; }
}

/* 激活:霓虹底 + 更亮描边 + 底部指示条 */
.nav-link.active {
  color: #fff;
  background: rgba(79, 141, 255, 0.22);
  border-color: rgba(120, 170, 255, 0.7);
  box-shadow:
      0 0 14px rgba(79, 141, 255, 0.55),
      inset 0 0 12px rgba(79, 141, 255, 0.25);
}
.nav-link.active::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 2px;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #4fd1ff, #9d7bff);
  box-shadow: 0 0 12px rgba(120, 200, 255, 0.9);
  animation: breathe 2.4s ease-in-out infinite;
}
@keyframes breathe {
  0%, 100% { opacity: 0.7; }
  50%      { opacity: 1; }
}

/* ========== 右侧按钮 ========== */
.nav-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.icon-btn {
  position: relative;
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  border: 1px solid rgba(120, 160, 255, 0.2);
  background: rgba(120, 160, 255, 0.06);
  color: rgba(220, 228, 255, 0.8);
  font-size: 17px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.25s ease;
}

/* 四角亮点:悬停时出现 */
.icon-btn::before,
.icon-btn::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  border: 1px solid rgba(120, 200, 255, 0.9);
  opacity: 0;
  transition: opacity 0.25s ease;
}
.icon-btn::before {
  top: 2px; left: 2px;
  border-right: none; border-bottom: none;
}
.icon-btn::after {
  bottom: 2px; right: 2px;
  border-left: none; border-top: none;
}

.icon-btn:hover {
  color: #fff;
  border-color: rgba(120, 200, 255, 0.8);
  background: rgba(79, 141, 255, 0.22);
  box-shadow:
      0 0 16px rgba(79, 141, 255, 0.55),
      inset 0 0 12px rgba(79, 141, 255, 0.2);
  transform: translateY(-1px);
}
.icon-btn:hover::before,
.icon-btn:hover::after {
  opacity: 1;
}
.icon-btn:active {
  transform: translateY(0) scale(0.96);
}

/* ========== 底部流光扫描线 ========== */
.scan-line {
  position: absolute;
  bottom: 0; left: 0;
  width: 30%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #6fa8ff, transparent);
  filter: blur(1px);
  animation: scan 6s linear infinite;
  opacity: 0.9;
}
@keyframes scan {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(430%); }
}

/* ========== 响应式 ========== */
@media (max-width: 768px) {
  .navbar-container { height: 60px; padding: 0 16px; gap: 12px; }
  .nav-menu { display: none; }
  .logo-text { font-size: 18px; }
}

@media (prefers-reduced-motion: reduce) {
  .scan-line, .logo-mark::after, .nav-link.active::after { animation: none; }
  * { transition: none !important; }
}
</style>